import React, { useState } from "react";
import _ from "lodash";
import { useSurveyContext } from "./components/SurveyDataProvider";
import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useNavigate } from "../../components/Navigate";
import ScreenWrapper from "../../components/layout/screenWrapper";
import DataDashboardSurveyDetails from "./components/datadashboardsurvey/details";
import DataDashboardSurveyList from "./components/datadashboardsurvey/table";
import DataDashboardSurveyFilter from "./components/datadashboardsurvey/filter";
import DataDashboardSurveyResults from "./components/datadashboardsurvey/results";
import ButtonControl from "../../components/controls/ButtonControl";
import { DialogControl } from "../../components/controls/DialogControl";
import MainLayout from "../../components/layout/MainLayout";
import GeneralSurveyPrintScreen from "./components/datadashboardsurvey/printscreen";
import GeneralSurveyPrintEmptyScreen from "./components/datadashboardsurvey/printemptysurvey";
import { useDistrictManager, useSchoolManager, useClusterManager } from "../../hooks/useManagers";
import { SelectListControl } from "../../components/controls";
import { InputField } from "../../components/controls/InputField";
import { FormatUTCDateTimeM } from "../../utilities/DateFormater";
import { trackSurveyEvent } from "../../utilities/analytics";
import { v4 as uuidv4 } from "uuid";

// Hardcoded GeneralSurvey.Id used by the backend (GeneralSurveyUserEventProcessor) to
// grant users with the TDOEDataDashboardSurveyEntry permission visibility into all
// UserSurveyMap entries tied to the TDOE / Tennessee Data Dashboard survey.
const TDOE_DATA_DASHBOARD_GENERAL_SURVEY_ID = "FF727803-B273-44BC-B181-E7D44CD1C46E";

const DataDashboardSurveys = () => {
  const { managerIsReady, dataDashboardSurveyMgr: generalSurveyMgr, surveyMgr, orgMgr, appUserMgr } =
    useSurveyContext();
  const basePath = "/survey/datadashboardsurvey";
  const districtMgr = useDistrictManager();
  const schoolMgr = useSchoolManager();
  const clusterMgr = useClusterManager();
  const [manageMode, setManageMode] = useState(null);
  const [loading, setLoading] = useState(false);
  const [orgTree, setOrgTree] = useState(null);
  const [districts, setDistricts] = useState(null);
  const [schools, setSchools] = useState(null);
  const [data, setData] = useState(null);
  const [printing, setPrinting] = useState(false);
  const [printData, setPrintData] = useState(null);
  const [saving, setSaving] = useState(false);
  const [gridData, setGridData] = useState(null);
  const [ratingSelectOptions, setRatingSelectOptions] = useState(null);
  const [rubricLoading, setRubricLoading] = useState(true);
  const [printEmpty, setPrintEmpty] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [openDeleteSurveyDialog, setOpenDeleteSurveyDialog] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [deleteClusterName, setDeleteClusterName] = useState(null);
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [allowEdit, setAllowEdit] = useState(surveyMgr?.AppUserState?.selectedSchoolYear == surveyMgr?.AppUserState?.currentSchoolYear);
  const [creatingSurvey, setCreatingSurvey] = useState(false);
  const [organizations, setOrganizations] = useState([]);
  const [clusters, setClusters] = useState([]);
  const [clustersLoading, setClustersLoading] = useState(false);
  const [showCreateSurveyDialog, setShowCreateSurveyDialog] = useState(false);
  const [newSurveyOrgId, setNewSurveyOrgId] = useState(null);
  const [newSurveyDistrictId, setNewSurveyDistrictId] = useState(null);
  const [newSurveySchoolId, setNewSurveySchoolId] = useState(null);
  const [newSurveyClusterId, setNewSurveyClusterId] = useState(null);
  
  useEffect(() => {
    // load user tree (always slow - can this be cached in browser?)
    const fetchOrgUserTreeAsync = async () =>
      orgMgr.loadOrgTree().then((r) => setOrgTree(r));

    if (
      managerIsReady &&
      generalSurveyMgr &&
      surveyMgr &&
      orgMgr &&
      appUserMgr &&
      schoolMgr &&
      districtMgr
    ) {
      let ignore = false;
      fetchOrgUserTreeAsync();
      setLoading(true);
      async function fetchData() {
        const promises = [];

        promises.push(
          schoolMgr.list().then((schoolResult) => {
            if (schoolResult.Items.length > 0) {
              if (schoolResult.Success) {
                let schoolsMapped = schoolResult.Items.map((item) => ({
                  Name: item.Name,
                  Id: item.Id,
                  DistrictId: item.DistrictId,
                  ClientId: item.ClientId,
                }));
                setSchools(schoolsMapped);
              }
            }
          })
        );

        promises.push(
          districtMgr.list().then((districtResult) => {
            if (districtResult.Items.length > 0) {
              if (districtResult.Success) {
                let validDistricts = districtResult.Items.filter(
                  (item) => item.ClientId !== null
                );
                let districtsMapped = validDistricts.map((item) => ({
                  Name: item.Name,
                  Id: item.Id,
                  ClientId: item.ClientId,
                }));
                setDistricts(districtsMapped);
              }
            }
          })
        );

        promises.push(
          orgMgr.list().then((orgResult) => {
            if (orgResult?.Success && orgResult?.Items?.length > 0) {
              let orgsMapped = orgResult.Items.map((item) => ({
                label: item.DisplayName ?? item.Name,
                value: item.Id,
              }));
              orgsMapped.sort((a, b) => a.label.localeCompare(b.label));
              setOrganizations(orgsMapped);
            }
          })
        );

        if (params?.surveyId) {
          handleParamChange();
        } else {
          promises.push(
            generalSurveyMgr.search(null, true).then((r) => {
              if (sessionStorage.getItem("FileUpload-content")) {
                sessionStorage.removeItem("FileUpload-content");
              }
              setData(dataMassager(scopeToDataDashboard(generalSurveyMgr?.FilteredData)));
              setLoading(false);
              setRatingSelectOptions(null);
              setManageMode("list");
            })
          );
        }

        // Run all promises concurrently
        Promise.all(promises).catch((err) => {
          console.error("Error fetching data:", err);
        });
      }
      fetchData();

      return () => {
        ignore = true;
      }; //cleanup
    }
  }, [
    managerIsReady,
    params,
    generalSurveyMgr,
    surveyMgr,
    orgMgr,
    appUserMgr,
    schoolMgr,
    districtMgr,
  ]);

  useEffect(() => {
    if (generalSurveyMgr?.FilteredData) {
      setData(dataMassager(scopeToDataDashboard(generalSurveyMgr?.FilteredData)));
    }
  }, [generalSurveyMgr?.FilteredData]);

  useEffect(() => {
    if (clusterMgr && newSurveySchoolId) {
      setClustersLoading(true);
      clusterMgr
        .list(
          clusterMgr.buildJSONObjFilter(
            "x => x.IsDeleted == false && x.SchoolId == sId",
            { sId: newSurveySchoolId }
          )
        )
        .then((r) => {
          if (r?.Success && r?.Items?.length > 0) {
            let clustersMapped = r.Items.map((item) => ({
              label: item.Name,
              value: item.Id,
            }));
            clustersMapped.sort((a, b) => a.label.localeCompare(b.label));
            setClusters(clustersMapped);
          } else {
            setClusters([]);
          }
          setClustersLoading(false);
        });
    } else {
      setClusters([]);
    }
  }, [clusterMgr, newSurveySchoolId]);

  const scopeToDataDashboard = (items) => {
    if (!true || !Array.isArray(items)) return items;
    return _.filter(
      items,
      (item) => item?.GeneralSurvey?.Id?.toLowerCase() === TDOE_DATA_DASHBOARD_GENERAL_SURVEY_ID.toLowerCase()
    );
  };

  const handleParamChange = async (item) => {
    if (_.isNil(item?.Survey) && item) {
      await surveyMgr
        .saveGeneralSurvey(
          {
            SurveyTemplateId: item.SurveyTemplateId,
            Name: item.GeneralSurveyName,
            RubricId: item.RubricId,
            SurveyType: 2,
            SurveyStatusType: 1,
          },
          item.Id
        )
        .then((r) => navigate(`${basePath}/${item.Id}`));
    } else {
      await generalSurveyMgr
        .RetrieveUserGeneralSurvey(params?.surveyId)
        .then((r) => {
          const surveyItem = dataMassager(r[0].Items[0]);
          if (location?.pathname.includes("review")) {
            if (
              surveyItem.SurveyStatusType == 2 ||
              surveyItem.SurveyStatusType == 3
            ) {
              setManageMode("viewResult");
            } else navigate(`${basePath}/${surveyItem.Id}`);
          } else if (surveyItem.SurveyStatusType == 3) {
            navigate(`${basePath}/review/${surveyItem.Id}`);
          } else setManageMode("view");
          setData(surveyItem);
          setLoading(false);
        });
    }
  };

  const handleRefreshData = async () => {
    setTableLoading(true);
    await generalSurveyMgr.search(null, true).then(() => {
      setData(dataMassager(scopeToDataDashboard(generalSurveyMgr?.FilteredData)));
      setTableLoading(false);
    });
  };

  const dataMassager = (items) => {
    if (Array.isArray(items)) {
      items = _.map(items, (item) => {
        if (item.GeneralSurvey) {
          return {
            ...item,
            GeneralSurveyName: item.GeneralSurvey.Name,
            StartDate:
              item?.UserSurveyMap?.Survey?.ActualSurveyDateStart &&
              FormatUTCDateTimeM(
                new Date(
                  item?.UserSurveyMap?.Survey?.ActualSurveyDateStart
                ).toISOString()
              ),
            EndDate: item?.UserSurveyMap?.Survey?.ActualSurveyDateEnd,
            AssignedTo: item.UserSurveyMap.User.FullName,
            AssignedByUserId: item.AssignedByUser.FullName,
            RubricName: item.GeneralSurvey.SurveyTemplate?.Rubric?.Name,
            RubricId: item.GeneralSurvey.SurveyTemplate?.Rubric?.Id,
            SurveyType: item.GeneralSurvey.SurveyTemplate.SurveyType,
            Survey: item.UserSurveyMap.Survey ?? null,
            SurveyTemplateId:
              item.GeneralSurvey.SurveyTemplate.SurveyTemplateId,
            IsActive: item.GeneralSurvey.IsActive,
            IsDeleted: item.GeneralSurvey.IsDeleted,
          };
        } else {
          return {
            AssignedTo: item.UserSurveyMap.User.FullName,
            AssignedBy: "Unknown",
            IsActive: false,
          };
        }
      });
    } else {
      if (items.GeneralSurvey) {
        items = {
          ...items,
          GeneralSurveyName: items.GeneralSurvey.Name,
          StartDate:
            items?.UserSurveyMap?.Survey?.ActualSurveyDateStart &&
            FormatUTCDateTimeM(
              new Date(
                items?.UserSurveyMap?.Survey?.ActualSurveyDateStart
              ).toISOString()
            ),
          AssignedTo: items.UserSurveyMap.User.FullName,
          AssignedByUserId: items.GeneralSurvey.AssignedByUserId,
          ShowRubric: items.GeneralSurvey.SurveyTemplate.ShowRubric,
          RubricName: items.GeneralSurvey.SurveyTemplate.Rubric?.Name,
          RubricId: items.GeneralSurvey.SurveyTemplate.Rubric?.Id,
          IncludeLikertNA: items.GeneralSurvey.SurveyTemplate.IncludeLikertNA,
          Survey: items.UserSurveyMap.Survey ?? null,
          SurveyType: items.GeneralSurvey.SurveyTemplate.SurveyType,
          SurveyTemplateId: items.GeneralSurvey.SurveyTemplate.SurveyTemplateId,
          SurveyTemplateFields: _.orderBy(
            items.GeneralSurvey.SurveyTemplate.SurveyTemplateFields,
            ["Sequence"],
            ["asc"]
          ),
          SurveyLikertMap: _.orderBy(
            items.GeneralSurvey.SurveyTemplate.SurveyLikertMap,
            ["Value"],
            ["asc"]
          ),
          SurveyStatusType: items.UserSurveyMap.Survey?.SurveyStatusType,
          SurveyDescription: items.GeneralSurvey?.Description,
          IsActive: items.GeneralSurvey.IsActive,
          IsDeleted: items.GeneralSurvey.IsDeleted,
        };
      } else {
        return {
          AssignedTo: items.UserSurveyMap.User.FullName,
          AssignedByUser: { FullName: "Unknown" },
          IsActive: false,
        };
      }
    }
    return items;
  };

  useEffect(() => {
    if ((data?.ShowRubric || printData?.ShowRubric) && !ratingSelectOptions) {
      setRubricLoading(true);
      generalSurveyMgr
        .getSurveyAndRubric(
          data?.Survey?.SurveyId ?? printData?.Survey?.SurveyId
        )
        .then((res) => {
          if (!res) {
            setRubricLoading("NoRubric");
          } else {
            setGridData(res.gridData);
            if (res.tagMap) {
              let ratingSelectOpts = {};

              Object.keys(res.tagMap).forEach((t) => {
                let selectedRatingValue = res.gridData.data?.reduce((r, cv) => {
                  if (
                    res.tagMap[t].name === cv.tag?.name &&
                    cv.selectedRating !== ""
                  ) {
                    r = cv.selectedRating;
                  }
                  return r;
                }, null);

                ratingSelectOpts[res.tagMap[t].name] = {
                  isExpanded: false,
                  surveyRatingId: res.gridData.data?.reduce((r, cv) => {
                    if (res.tagMap[t].name === cv.tag?.name) {
                      r = cv.surveyRatingId;
                    }
                    return r;
                  }, null),
                  selectedRating: selectedRatingValue,
                  rubricRatingId: _.find(
                    res.gridData.metaData,
                    (y) => y.rating === selectedRatingValue
                  )?.rubricRatingId,
                  rubricIndicatorId: res.tagMap[t].id,
                };
              });
              setRatingSelectOptions(ratingSelectOpts);
              setRubricLoading(false);
            }
          }
        });
    } else if (
      (data && !data.ShowRubric) ||
      (printData && !printData.ShowRubric)
    ) {
      setRubricLoading("NoRubric");
    }
  }, [data, printData]);

  const handleOnFilterChange = async (field, value) => {
    const surveyFilter = generalSurveyMgr.Filter;
    const updatedSurveyFilter = { ...surveyFilter };
    updatedSurveyFilter[field] = value !== "" ? value : null;
    await generalSurveyMgr.filterData(updatedSurveyFilter);
  };

  const handleOnSave = async (item, condition) => {
    const spreadItem = {
      ...item,
      RubricId: data.RubricId,
      SurveySections: _.map(item.SurveySections, (ss) => {
        return {
          ...ss,
          Value: Array.isArray(ss.Value) ? ss?.Value?.join(";") : ss?.Value,
          Options: undefined,
          SurveyFieldType: undefined,
        };
      }),
    };

    var result = await surveyMgr.saveGeneralSurvey(spreadItem, data.Id);
    if (result.first() && !condition) {
      navigate(-1);
    } else if (result.first() && condition === "NEXT") {
      navigate(`${basePath}/review/${data?.Id}`);
    } else if (result.first() && condition === "SUBMIT") {
      trackSurveyEvent(spreadItem.Id, 'general', data?.GeneralSurveyName);
      navigate(basePath);
    }
    setRatingSelectOptions(null);
    return result;
  };
  const handleOnEdit = (item) => {
    //We have yet to create a survey for the general survey DTI.
    if (_.isNil(item?.Survey)) {
      setLoading(true);
      handleParamChange(item);
    } else {
      navigate(`${basePath}/${item.Id}`);
    }
  };

  const handleOnView = (item) => {
    navigate(`${basePath}/review/${item?.Id}`);
  };

  const handleOnDelete = async (survey) => {
    setSelectedItem(survey);
    setDeleteClusterName(null);
    setOpenDeleteSurveyDialog(true);
    const clusterId = survey?.Survey?.ClusterId;
    if (clusterId && clusterMgr) {
      const clusterResult = await clusterMgr.get(clusterId);
      const clusterItem = clusterResult?.Items?.first();
      if (clusterItem) {
        setDeleteClusterName(clusterItem.Name);
      }
    }
  };

  const deleteSurvey = async (item) => {
    setSaving(true);
    if (item?.Survey && item?.UserSurveyMap) {
      const surveyToDelete = { ...item.Survey, IsDeleted: true, IsActive: false };
      const userSurveyMapToDelete = { ...item.UserSurveyMap, IsDeleted: true, IsActive: false };

      const [surveyResult, userSurveyMapResult] = await Promise.all([
        surveyMgr.save(surveyToDelete),
        generalSurveyMgr.saveUser(userSurveyMapToDelete),
      ]);

      const surveySuccess = surveyResult?.first
        ? surveyResult.first()?.Success
        : surveyResult?.Success;
      const userSurveyMapSuccess = userSurveyMapResult?.first
        ? userSurveyMapResult.first()?.Success
        : userSurveyMapResult?.Success;

      if (surveySuccess && userSurveyMapSuccess) {
        setData((prevData) =>
          Array.isArray(prevData)
            ? prevData.filter((x) => x.Id !== item.Id)
            : prevData
        );
      }
    }
    setSaving(false);
  };
  
  const handleOnPrintReport = async (survey, location) => {
    setPrinting(survey.Id);
    if (location === "review") {
      setPrintData(survey);
    } else {
      const r = await generalSurveyMgr.RetrieveUserGeneralSurvey(survey?.Id);
      setPrintData(dataMassager(r[0].Items[0]));
    }
  };

  const printingCompleted = () => {
    setPrinting(false);
    setPrintData(null);
    setPrintEmpty(false);
    setRubricLoading(false);
    if (!params.surveyId) {
      setRatingSelectOptions(null);
    }
  };

  const handlePrintEmpty = async (survey) => {
    const r = await generalSurveyMgr.RetrieveUserGeneralSurvey(survey?.Id);
    setPrintData(dataMassager(r[0].Items[0]));
    setPrintEmpty(true);
  };

  const handleOnOpenCreateSurveyDialog = () => {
    setNewSurveyOrgId(null);
    setNewSurveyDistrictId(null);
    setNewSurveySchoolId(null);
    setNewSurveyClusterId(null);
    setClusters([]);
    setShowCreateSurveyDialog(true);
  };

  const handleOnCancelCreateSurveyDialog = () => {
    setShowCreateSurveyDialog(false);
  };

  const handleOnCreateSurveyOrgChange = (value) => {
    setNewSurveyOrgId(value);
    setNewSurveyDistrictId(null);
    setNewSurveySchoolId(null);
    setNewSurveyClusterId(null);
  };

  const handleOnCreateSurveyDistrictChange = (value) => {
    setNewSurveyDistrictId(value);
    setNewSurveySchoolId(null);
    setNewSurveyClusterId(null);
  };

  const handleOnCreateSurveySchoolChange = (value) => {
    setNewSurveySchoolId(value);
    setNewSurveyClusterId(null);
  };

  const handleOnCreateSurveyClusterChange = (value) => {
    setNewSurveyClusterId(value);
  };

  const handleOnCreateNewSurvey = async () => {
    setCreatingSurvey(true);
    try {
      const newUserSurveyMapId = uuidv4();

      const generalSurveyResult = await generalSurveyMgr.get(TDOE_DATA_DASHBOARD_GENERAL_SURVEY_ID);
      if (!generalSurveyResult?.Items?.first()) {
        setCreatingSurvey(false);
        console.error("Failed to fetch GeneralSurvey");
        return { Success: false, MessageDetails: ["Failed to fetch the survey template. Please try again."] };
      }

      const generalSurvey = generalSurveyResult.Items.first();
      const newUserSurveyMap = {
        Id: newUserSurveyMapId,
        UserId: appUserMgr.AppUserState.userProfile.Id,
        GeneralSurveyId: TDOE_DATA_DASHBOARD_GENERAL_SURVEY_ID,
        SurveyStartDate: new Date().toISOString(),
        ClientId: newSurveyOrgId,
        DateSent: new Date().toISOString(),
      };

      const updateUsersResult = await generalSurveyMgr.UpdateUsers([newUserSurveyMap]);
      if (!updateUsersResult?.first()?.first()?.Success) {
        setCreatingSurvey(false);
        console.error("Failed to create UserSurveyMap");
        return { Success: false, MessageDetails: ["Failed to create the survey assignment. Please try again."] };
      }

      const surveyItem = {
        SurveyTemplateId: generalSurvey.SurveyTemplate.Id,
        Name: generalSurvey.Name,
        RubricId: generalSurvey.SurveyTemplate.Rubric?.Id,
        SurveyType: 2,
        SurveyStatusType: 1,
        ClientId: newSurveyOrgId,
        DistrictId: newSurveyDistrictId,
        SchoolId: newSurveySchoolId,
        ClusterId: newSurveyClusterId,
        SurveyDisplayType: 2, // Final
        SurveyedUserPosition: 100, // Individual
        UserPositionType: 100, // Individual
        SchoolYearIdentifier: surveyMgr?.AppUserState?.selectedSchoolYear,
      };

      const saveResult = await surveyMgr.saveGeneralSurvey(surveyItem, newUserSurveyMapId);
      if (!saveResult || saveResult.length === 0) {
        await generalSurveyMgr.UpdateUsers([{ ...newUserSurveyMap, IsDeleted: true }]);
        setCreatingSurvey(false);
        console.error("Failed to create Survey, cleaned up UserSurveyMap");
        return { Success: false, MessageDetails: ["Failed to create the survey. Please try again."] };
      }

      setCreatingSurvey(false);
      setShowCreateSurveyDialog(false);
      navigate(`${basePath}/${newUserSurveyMapId}`);
      return { Success: true };
    } catch (error) {
      setCreatingSurvey(false);
      console.error("Error creating survey:", error);
      return { Success: false, MessageDetails: ["An unexpected error occurred while creating the survey."] };
    }
  };


  return (
    <>
      <DialogControl
        title={`Delete Survey?`}
        loadingSave={saving}
        openDialog={openDeleteSurveyDialog}
        okText={`Delete`}
        onCancel={() => {
          setSelectedItem(null);
          setDeleteClusterName(null);
          setOpenDeleteSurveyDialog(false);
        }}
        onOk={async () => {
          setSaving(true);
          await deleteSurvey(selectedItem);
          setOpenDeleteSurveyDialog(false);
          setSaving(false);
          setSelectedItem(null);
          setDeleteClusterName(null);
        }}
      >
        <div className="delete-survey-details">
          <div className="survey-subheader-wrapper">
            <div className="details-content"><strong>{selectedItem?.GeneralSurveyName}</strong></div>
            <div className="details-content">{selectedItem?.FullOrg} {deleteClusterName}</div>
            <div className="details-content">{selectedItem?.DataCollectionPeriod}</div>
            <div className="details-content">Surveyed <strong>{selectedItem?.TeacherName}</strong> 
              &nbsp;on&nbsp;<strong>{selectedItem?.StartDate}</strong></div>
          </div>
        </div>
      </DialogControl>
      <DialogControl
        title={`Create New Survey`}
        subTitle={`Select the Organization, District, School, and Cluster for this survey.`}
        openDialog={showCreateSurveyDialog}
        okText={`OK`}
        loadingOk={creatingSurvey}
        disableOk={!(newSurveyOrgId && newSurveyDistrictId && newSurveySchoolId && newSurveyClusterId)}
        onCancel={handleOnCancelCreateSurveyDialog}
        onOk={handleOnCreateNewSurvey}
      >
        <div className="filterControl">
          <InputField id="newSurveyOrg" title="Organization" fieldName="newSurveyOrg" disableError={true}>
            <SelectListControl
              searchable
              placeholder="Select Organization"
              value={newSurveyOrgId}
              data={organizations}
              onChange={(value) => handleOnCreateSurveyOrgChange(value)}
            />
          </InputField>
        </div>
        <div className="filterControl">
          <InputField id="newSurveyDistrict" title="District" fieldName="newSurveyDistrict" disableError={true}>
            <SelectListControl
              searchable
              placeholder="Select District"
              disabled={!newSurveyOrgId}
              value={newSurveyDistrictId}
              data={
                districts
                  ?.filter((d) => d.ClientId === newSurveyOrgId)
                  ?.map((d) => ({ label: d.Name, value: d.Id })) ?? []
              }
              onChange={(value) => handleOnCreateSurveyDistrictChange(value)}
            />
          </InputField>
        </div>
        <div className="filterControl">
          <InputField id="newSurveySchool" title="School" fieldName="newSurveySchool" disableError={true}>
            <SelectListControl
              searchable
              placeholder="Select School"
              disabled={!newSurveyDistrictId}
              value={newSurveySchoolId}
              data={
                schools
                  ?.filter((s) => s.DistrictId === newSurveyDistrictId)
                  ?.map((s) => ({ label: s.Name, value: s.Id })) ?? []
              }
              onChange={(value) => handleOnCreateSurveySchoolChange(value)}
            />
          </InputField>
        </div>
        <div className="filterControl">
          <InputField id="newSurveyCluster" title="Cluster" fieldName="newSurveyCluster" disableError={true}>
            <SelectListControl
              searchable
              placeholder="Select Cluster"
              disabled={!newSurveySchoolId}
              loading={clustersLoading}
              value={newSurveyClusterId}
              data={clusters}
              onChange={(value) => handleOnCreateSurveyClusterChange(value)}
            />
          </InputField>
        </div>
      </DialogControl>
      {printing &&
        printData &&
        (!printData.ShowRubric ||
          (printData.ShowRubric && rubricLoading !== true)) && (
          <GeneralSurveyPrintScreen
            data={printData}
            rubricData={gridData}
            rubricLoading={rubricLoading}
            printingCompleted={printingCompleted}
          />
        )}
      {printEmpty &&
        printData &&
        (!printData.ShowRubric ||
          (printData.ShowRubric && rubricLoading !== true)) && (
          <GeneralSurveyPrintEmptyScreen
            printingCompleted={printingCompleted}
            generalSurveyMgr={generalSurveyMgr}
            data={printData}
            rubricLoading={rubricLoading}
            rubricData={gridData}
            ratingSelectOptions={ratingSelectOptions}
            setRatingSelectOptions={setRatingSelectOptions}
          />
        )}
      <MainLayout>
        <ScreenWrapper loading={loading} className={" survey-wrapper"}>
          {(manageMode === "view" || manageMode === "viewResult") && (
            <>
              <div className="survey-screen-header">
                <div className="survey-header-row">
                  <div className="survey-header-wrapper">
                    <h1>{data?.GeneralSurveyName}</h1>
                    {data.SurveyStatusType == 3 && (
                      <div className="survey-status">SUBMITTED</div>
                    )}
                  </div>
                  <div className="survey-subheader-wrapper">
                    <div className="survey-subheader-left">
                      Survey Assigned By:
                    </div>
                    <div className="survey-subheader-right">
                      {data?.AssignedByUser?.FullName}
                    </div>
                  </div>
                  <div className="survey-subheader-wrapper">
                    <div className="survey-subheader-left">
                      Survey Assigned To:
                    </div>
                    <div className="survey-subheader-right">
                      {data?.AssignedTo}
                    </div>
                  </div>
                  {/* <div className="survey-subheader-wrapper">
                                    <div className="survey-subheader-left">Start Date:</div>
                                    <div className="survey-subheader-right"> {moment.utc(data?.StartDate).local().format("MMMM D, YYYY")}</div>
                                </div> */}
                </div>
                {manageMode === "viewResult" && (
                  <div className="survey-header-button-wrapper">
                    <ButtonControl
                      type={"cancel"}
                      loading={printing}
                      onClick={() => handleOnPrintReport(data, "review")}
                    >
                      Print Report
                    </ButtonControl>
                    {data?.SurveyStatusType != 3 && (
                      <ButtonControl
                        type={"cancel"}
                        onClick={() => {
                          navigate(`${basePath}/${data.Id}`);
                        }}
                      >
                        EDIT SURVEY
                      </ButtonControl>
                    )}
                    <ButtonControl
                      type={"cancel"}
                      onClick={() => {
                        navigate(basePath);
                        setRatingSelectOptions(null);
                      }}
                    >
                      {data?.Survey?.SurveyStatusType == 3
                        ? "EXIT"
                        : "CONTINUE LATER"}
                    </ButtonControl>
                    {data?.Survey?.SurveyStatusType == 2 && (
                      <ButtonControl
                        type={"okay"}
                        loading={saving}
                        onClick={() => {
                          const copySurvey = { ...data.Survey };
                          copySurvey.SurveyStatusType = 3;
                          setSaving(true);
                          const result = handleOnSave(copySurvey, "SUBMIT");
                          if (result) {
                            setSaving(false);
                          }
                        }}
                      >
                        SUBMIT
                      </ButtonControl>
                    )}
                  </div>
                )}
              </div>
              {data && manageMode === "view" && !printEmpty && (
                <DataDashboardSurveyDetails
                  generalSurveyMgr={generalSurveyMgr}
                  data={data}
                  saveSurvey={handleOnSave}
                  rubricLoading={rubricLoading}
                  rubricData={gridData}
                  ratingSelectOptions={ratingSelectOptions}
                  setRatingSelectOptions={setRatingSelectOptions}
                />
              )}
            </>
          )}
          {manageMode === "list" && (
            <div className="control-box-wrapper">
              <div className="control-box-list">
                <DataDashboardSurveyFilter
                  generalSurveyMgr={generalSurveyMgr}
                  orgMgr={orgMgr}
                  orgTree={orgTree}
                  onFilterChange={handleOnFilterChange}
                />
                <ScreenWrapper loading={tableLoading}>
                  <DataDashboardSurveyList
                    printing={printing}
                    handlePrintEmpty={handlePrintEmpty}
                    appUserMgr={appUserMgr}
                    generalSurveyMgr={generalSurveyMgr}
                    filteredItems={data ?? []}
                    orgs={orgTree}
                    districts={districts}
                    schools={schools}
                    onEdit={allowEdit ? handleOnEdit : null}
                    onPrint={handleOnPrintReport}
                    onView={handleOnView}
                    onDelete={allowEdit ? handleOnDelete : null}
                    allowEdit={allowEdit}
                  />
                </ScreenWrapper>
              </div>
              <div className="screen-footer list">
                {allowEdit && (
                  <ButtonControl
                    type={"okay"}
                    onClick={handleOnOpenCreateSurveyDialog}
                    disabled={creatingSurvey || tableLoading}
                    loading={creatingSurvey}
                  >
                    Create New Survey
                  </ButtonControl>
                )}
                <ButtonControl
                  type={"okay"}
                  onClick={handleRefreshData}
                  disabled={tableLoading || creatingSurvey}
                >
                  Refresh
                </ButtonControl>
              </div>
            </div>
          )}
          {manageMode === "viewResult" && (
            <DataDashboardSurveyResults
              data={data}
              rubricData={gridData}
              rubricLoading={rubricLoading}
            />
          )}
        </ScreenWrapper>
      </MainLayout>
    </>
  );
};

export default DataDashboardSurveys;
